import { cva, type VariantProps } from '@mentimeter/ragnar-tailwind-config';

export const inputVariants = cva(
  [
    'box-border',
    'block',
    'w-full',
    'appearance-none',
    'font-body',
    'cursor-auto',
    'focus:text-text',
    'focus-visible:outline-solid',
    'focus-visible:outline-offset-2',
    'focus-visible:outline-4',
    'focus-visible:outline-interactive-focused',
    'disabled:bg-disabled-strong',
    'disabled:text-on-disabled-strong',
    'disabled:placeholder:text-on-disabled-strong',
    'disabled:cursor-not-allowed',
    'placeholder:text-text-weaker',
    'transition-[padding]',
    'duration-300',
    'ease-in-out',
  ],
  {
    variants: {
      variant: {
        filled: ['focus:bg-bg'],
        outline: ['bg-transparent'],
      },
      status: {
        idle: [
          'text-text',
          'hover:enabled:shadow-[inset_0_0_0_2px_theme(colors.secondary.DEFAULT)]',
          'focus:enabled:shadow-[inset_0_0_0_2px_theme(colors.secondary.DEFAULT)]',
        ],
        error: [
          'text-on-negative-weakest',
          'enabled:shadow-[inset_0_0_0_2px_theme(colors.negative.DEFAULT)]',
        ],
        success: [
          'text-on-positive-weakest',
          'enabled:shadow-[inset_0_0_0_2px_theme(colors.positive.DEFAULT)]',
        ],
      },
      size: {
        compact: ['py-3', 'px-2', 'rounded-lg', 'text-87-5', 'leading-100'],
        default: ['p-4', 'rounded-xl', 'text-100', 'leading-125'],
      },
    },
    compoundVariants: [
      {
        variant: 'filled',
        status: 'idle',
        class: [
          'bg-input-bg',
          'enabled:shadow-[inset_0_0_0_2px_var(--color-border-weaker)]',
        ],
      },
      {
        variant: 'filled',
        status: 'error',
        class: ['bg-negative-weakest', 'hover:enabled:bg-bg'],
      },
      {
        variant: 'filled',
        status: 'success',
        class: ['bg-positive-weakest', 'hover:enabled:bg-bg'],
      },
      {
        variant: 'outline',
        status: 'idle',
        class: [
          'enabled:shadow-[inset_0_0_0_1px_theme(colors.border.stronger)]',
        ],
      },
    ],
    defaultVariants: {
      variant: 'filled',
      status: 'idle',
      size: 'default',
    },
  },
);

export type InputVariantProps = VariantProps<typeof inputVariants>;
